class AbstractSftpController extends AbstractIntegrationController
	@inject '$filter',
		'$scope',
		'$state',
		'Integration',
		'IntegrationConfiguration',
		'IntegrationRepository',
		'ToastService'

	integrationId: 'sftp'

	initialize: ->
		@$scope.changingPassword = false
		@$scope.integration = @Integration.data
		@$scope.configuration =
			path: './'
			port: 22
			is_sftp: true
			isSftp: true # TODO: legacy remove when all integrations use is_sftp

		@$scope.hasErrorData = angular.isDefined(@IntegrationConfiguration.data?.errorCode) ||
			angular.isDefined(@IntegrationConfiguration.data?.error)

		if not _.isEmpty(@IntegrationConfiguration.data) and !@$scope.hasErrorData
			@$scope.configuration = _.extend(
				@$scope.configuration
				@IntegrationConfiguration.data
			)

			@$scope.isNew = false
		else
			@$scope.isNew = true

		@$scope.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-sftp-config'
			}
			{
				title: 'wbo.integrations.failed.transfers'
				selector: '#failed-transfers'
			}
		]

	save: ->
		super(@$scope.configuration).then => @$scope.isNew = false

	runIntegration: () =>
		@$scope.saving = true

		@IntegrationRepository
			.run @integrationId
			.then (response) =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('alert.updated'),
					'success'
				)
			.finally =>
				@$scope.saving = false
